import JobSurveyList from "components/ChallengeComponents/ChallengeDetailsComponents/JobSurvey/JobSurveyList";
import Header from "components/Common/Header/Header";
import React from "react";

const JobSurvey = () => {
  return (
    <main id="app">
      {/* ---- common header ---- */}
      <Header moduleName="challenges" />

      {/* ---------- body section ------------- */}
      <JobSurveyList />
    </main>
  );
};

export default JobSurvey;
